
import React, { useState, useEffect } from 'react';
import {
    Text, View, Image, StyleSheet, ScrollView, Pressable
} from 'react-native';
import { store } from "../../store/store";
import { getMemberProfileURL } from '../../utils/services/CommonUtils';
import { CommonAddMemberHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import { familyDetailsSubscription } from "../../utils/services/subject-behaviour/CommonRxjsService";
import { updateAddUpdateScreenData } from '../../utils/services/redux/commonRedux';
import { CommonRightChevronIcon } from '../../utils/widgets/Common-Widget';
import { ScreenRoute } from '../../utils/constants/ScreenRouteConstant';

import AppStyles from "../../AppStyles";
import AppTheme from "../../AppTheme";
import OmsStyles from '../../OmsStyle';

import * as CommonUtils from '../../utils/services/CommonUtils';
import TextStyle from '../../TextStyle';

const MemberSelectionScreen = (props) => {

    function addMember() {

        updateAddUpdateScreenData({
            isUpdate: false, user: null, screenName: ScreenRoute.member_selection,
            isSelf: false, props: props
        })
        props.navigation.navigate(ScreenRoute.upsert_family_data)
    }

    const [familyData, updateFamilyData] = useState({
        familyMembers: [],
        isProfileComplete: false
    })
    // const [memberSelection, updateSelectedMember] = useState({
    //     'selectedMemberIndex': 0,
    //     'consultationParams': { 'selectedMember': familyData.familyMembers[0] }
    // });

    useEffect(() => {

        const reduxState = store.getState();
        if (reduxState.familydetails instanceof Object &&
            Object.keys(reduxState.familydetails).length > 0) {
            updateFamilyData({
                familyMembers: reduxState['familydetails']['familyMembers'],
                isProfileComplete: reduxState.userDetails['isProfileComplete']
            });
            // updateSelectedMember({
            //     selectedMemberIndex: 0,
            //     consultationParams: {
            //         selectedMember: reduxState['familydetails']['familyMembers'][0]
            //     }
            // })
        }
        familyDetailsSubscription.getFamilyDetails().
            subscribe((familyData: any) => {
                if (familyData) {
                    let familyMembers: any = [...familyData]
                    updateFamilyData({
                        familyMembers: familyMembers,
                        isProfileComplete: true
                    });
                }
            })
    }, [])

    function redirectToCategoryOrAddMember(member) {
        if (familyData.isProfileComplete) {
            props.navigation.navigate(
                ScreenRoute.problem_selection,
                {
                    consultationParams: {
                        selectedMember: member
                    }
                })
        } else {
            updateAddUpdateScreenData({
                isUpdate: true,
                user: familyData['familyMembers'][0],
                screenName: ScreenRoute.member_selection,
                isSelf: true,
                props: props
            })
            setTimeout(() => {
                props.navigation.navigate(
                    ScreenRoute.upsert_family_data)
            },
                100)
        }
    }


    return (
        <View>
            <CommonAddMemberHeader navigation={props.navigation}
                title='E-Consult' addMember={addMember} />
            <ScrollView style={{
                marginTop: AppTheme.headerHeight,
                height: AppTheme.appHeight - AppTheme.headerHeight,
                backgroundColor: AppTheme.color.background,
                paddingBottom: 24
            }}>
                {
                    familyData.familyMembers.length > 0 &&
                    <Text style={[TextStyle.text18b,
                    { marginHorizontal: 16, marginVertical: 16 }]}>
                        Choose your family member</Text>}
                {
                    familyData.familyMembers.map((member, i) => (
                        <View key={i}>
                            <Pressable style={[styles.members,
                            AppStyles.mediumShadow,
                            AppStyles.flexRowSpaceBetween]}
                                onPress={() => {
                                    redirectToCategoryOrAddMember(member)
                                }}>
                                <View style={[AppStyles.flexRow]}>
                                    <View>
                                        <Image source={{
                                            uri: getMemberProfileURL(member),
                                            width: 46, height: 46
                                        }}
                                            style={{ borderRadius: 50, borderWidth: 1, borderColor: AppTheme.color.lightGreyColor }}></Image>
                                    </View>
                                    <View style={{ width: 16 }} />
                                    <View>
                                        <Text numberOfLines={1} style={[OmsStyles.text14b, { width: AppTheme.appWidth - 135 }]}>{member['name']}</Text>
                                        <View style={{ height: 10 }} />
                                        <Text style={[OmsStyles.text12b, { color: AppTheme.color.grey.fillerInfo }]}>({member['relation']})</Text>
                                    </View></View>
                                {CommonRightChevronIcon('black')}
                            </Pressable>
                        </View>
                    ))
                }
            </ScrollView>
        </View>

    )

}

export default MemberSelectionScreen;


// export default MemberSelection;

const styles = StyleSheet.create(CommonUtils.addFontFamilylato({
    members: {
        marginHorizontal: 16, marginBottom: 16, elevation: 18, paddingVertical: 16, paddingHorizontal: 16,
        borderRadius: 12, backgroundColor: 'white'
    },
    memberName: { fontSize: 14, color: '#000000', paddingVertical: 5, paddingLeft: 8 },
    memberRelation: { fontSize: 12, color: '#a6a6a6', paddingLeft: 8 },
    addMember: { fontSize: 16, color: AppTheme.color.primary, paddingLeft: 8 },
    outlineButton: {
        padding: 5,
        backgroundColor: '#ffffff',
        borderRadius: 34,
        color: '#ffffff',
        borderColor: AppTheme.color.primary,
        borderWidth: 1,
        paddingRight: 16
    },
    Member: {
        padding: 10,
        width: '25%',
        position: "relative",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        fontWeight: 12

    },
    patientLabel: {
        fontSize: 16,
        fontWeight: 600,
        color: '#333333',
        left: 16
    },
    submit: {
        backgroundColor: '#ffffff', height: 20, padding: 2,
        borderRadius: 13.5, color: '#ffffff', borderColor: '#1480fe', width: 130, borderWidth: 1
    },
    submitText: {
        color: '#1480fe',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: 12,
    },
    flexRow: {
        flex: 1,
        flexDirection: "row",
        // justifyContent: "space-between",
    },
    flexContainer: {
        flex: 1,
        flexDirection: "row",
        flexWrap: 'wrap',
        // overflow:   
    },
    memberContainer: {
        flex: 1,
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        alignSelf: 'flex-end',
        flexDirection: 'column'
    },

    addMemberHead: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    }

}))

